import SidePanel from './SidePanel'
import './SidePanel.sass'

export default SidePanel
